import { createSignalAction, createSimpleCreator } from "shared/reduxUtils"

const BASE = "MORTGAGE"

export const getCurrentRates = createSignalAction(BASE, "GET_CURRENT_RATES")
export const updateCurrentRates = createSignalAction(BASE, "UPDATE_CURRENT_RATES")